"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("./Button"));
const TextInput_1 = __importDefault(require("./TextInput"));
const MultiPlayerPage_1 = require("../MultiPlayerPage");
const MultiPlayerHostForm = ({ onGameStart }) => {
    const classes = (0, MultiPlayerPage_1.useStyles)();
    const [nickname, setNickname] = (0, react_1.useState)("");
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleChange = (event) => {
        setNickname(event.target.value);
    };
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setIsLoading(true);
        const result = yield fetch("/api/new-game", {
            method: "POST",
            body: JSON.stringify({ nickname }),
        }).then((res) => res.json());
        setIsLoading(false);
        onGameStart({ code: result.code, nickname, player: "P1" });
    });
    return (react_1.default.createElement("form", { className: classes.form, onSubmit: handleSubmit },
        react_1.default.createElement(TextInput_1.default, { className: classes.input, name: "nickname", value: nickname, label: "Nickname", error: null, onChange: handleChange, placeholder: "John Doe", autoFocus: true, required: true, disabled: isLoading }),
        react_1.default.createElement(Button_1.default, { className: classes.button }, "Host a new game")));
};
exports.default = MultiPlayerHostForm;
